'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Stack, Typography } from '@mui/material';
import Image from 'next/image';
import ErrorImage from '../../public/statics/images/illustrations/error.png';
interface ErrorPageProps {
  errorMessage: string;
  title: string;
  showBackButton?: boolean;
}
export function ErrorPage(props) {
  const $ = _c(11);
  const {
    errorMessage,
    title,
    showBackButton: t0
  } = props;
  const showBackButton = t0 === undefined ? true : t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Image alt="error" src={ErrorImage} width={546} height={533} loading="eager" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <Typography variant="h3">{title}</Typography>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== errorMessage) {
    t3 = <Typography variant="body1">{errorMessage}</Typography>;
    $[3] = errorMessage;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== showBackButton) {
    t4 = showBackButton && <Button onClick={_temp} variant="outlined">Back</Button>;
    $[5] = showBackButton;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = <Stack flexGrow={1} alignItems="center" justifyContent="center" gap="24px" className="mt-[-40px]">{t1}{t2}{t3}{t4}</Stack>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
function _temp() {
  return history.back();
}